export const fallBackQuantityUnit = 'Stück';

export const fallBackSalesUnit = 1;

export const fallBackPosition = 1;
